








import { Component, Mixins, Emit } from "vue-property-decorator";
import { SingleSelectableMixin } from "./mixins";

@Component({
})
export default class CardSelector extends Mixins(SingleSelectableMixin) {
  @Emit("click")
  onClicked(item: any) {
    this.selectedOption = item;
  }
}
